import {
	USER_REFRESH_TOKEN_KEY_LOCAL_STORAGE,
	USER_TOKEN_KEY_LOCAL_STORAGE,
} from "@constants/constants";

// The shell is rendered in Node too (the build prerender, and every request the
// dev server answers), where `__root`'s not-found redirect asks for the token.
// There is no localStorage there, and no session either — so no token.
const storage = (): Storage | null =>
	typeof window === "undefined" ? null : window.localStorage;

// localStorage, not sessionStorage: the session is shared across tabs and
// with the other zypl apps on this origin, which read the same keys.
export const tokenInstance = {
	setToken: (token: string) => {
		storage()?.setItem(USER_TOKEN_KEY_LOCAL_STORAGE, token);
	},
	getToken: () => storage()?.getItem(USER_TOKEN_KEY_LOCAL_STORAGE) ?? null,
	setRefreshToken: (token: string) => {
		storage()?.setItem(USER_REFRESH_TOKEN_KEY_LOCAL_STORAGE, token);
	},
	getRefreshToken: () =>
		storage()?.getItem(USER_REFRESH_TOKEN_KEY_LOCAL_STORAGE) ?? null,
	clearToken: () => {
		storage()?.removeItem(USER_TOKEN_KEY_LOCAL_STORAGE);
		storage()?.removeItem(USER_REFRESH_TOKEN_KEY_LOCAL_STORAGE);
	},
};
